/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { addBinaryReference } from '../fn/binary/add-binary-reference';
import { AddBinaryReference$Params } from '../fn/binary/add-binary-reference';
import { BinaryUploadInfoDto } from '../models/binary-upload-info-dto';
import { uploadBinaryByNamingConvention } from '../fn/binary/upload-binary-by-naming-convention';
import { UploadBinaryByNamingConvention$Params } from '../fn/binary/upload-binary-by-naming-convention';
import { uploadBinaryToLot } from '../fn/binary/upload-binary-to-lot';
import { UploadBinaryToLot$Params } from '../fn/binary/upload-binary-to-lot';

@Injectable({ providedIn: 'root' })
export class GeneratedBinaryService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `addBinaryReference()` */
  static readonly AddBinaryReferencePath = '/api/binaries/sha1/{sha1}/refs';

  /**
   * Adds a reference to an existing binary.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `addBinaryReference()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  addBinaryReference$Response(params: AddBinaryReference$Params, context?: HttpContext): Observable<StrictHttpResponse<BinaryUploadInfoDto>> {
    return addBinaryReference(this.http, this.rootUrl, params, context);
  }

  /**
   * Adds a reference to an existing binary.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `addBinaryReference$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  addBinaryReference(params: AddBinaryReference$Params, context?: HttpContext): Observable<BinaryUploadInfoDto> {
    return this.addBinaryReference$Response(params, context).pipe(
      map((r: StrictHttpResponse<BinaryUploadInfoDto>): BinaryUploadInfoDto => r.body)
    );
  }

  /** Path part for operation `uploadBinaryToLot()` */
  static readonly UploadBinaryToLotPath = '/api/binaries/lots/{lotId}';

  /**
   * Uploads a new binary.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `uploadBinaryToLot()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  uploadBinaryToLot$Response(params: UploadBinaryToLot$Params, context?: HttpContext): Observable<StrictHttpResponse<BinaryUploadInfoDto>> {
    return uploadBinaryToLot(this.http, this.rootUrl, params, context);
  }

  /**
   * Uploads a new binary.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `uploadBinaryToLot$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  uploadBinaryToLot(params: UploadBinaryToLot$Params, context?: HttpContext): Observable<BinaryUploadInfoDto> {
    return this.uploadBinaryToLot$Response(params, context).pipe(
      map((r: StrictHttpResponse<BinaryUploadInfoDto>): BinaryUploadInfoDto => r.body)
    );
  }

  /** Path part for operation `uploadBinaryByNamingConvention()` */
  static readonly UploadBinaryByNamingConventionPath = '/api/binaries/auctions/{auctionId}';

  /**
   * Uploads a new binary by naming convention.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `uploadBinaryByNamingConvention()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  uploadBinaryByNamingConvention$Response(params: UploadBinaryByNamingConvention$Params, context?: HttpContext): Observable<StrictHttpResponse<BinaryUploadInfoDto>> {
    return uploadBinaryByNamingConvention(this.http, this.rootUrl, params, context);
  }

  /**
   * Uploads a new binary by naming convention.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `uploadBinaryByNamingConvention$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  uploadBinaryByNamingConvention(params: UploadBinaryByNamingConvention$Params, context?: HttpContext): Observable<BinaryUploadInfoDto> {
    return this.uploadBinaryByNamingConvention$Response(params, context).pipe(
      map((r: StrictHttpResponse<BinaryUploadInfoDto>): BinaryUploadInfoDto => r.body)
    );
  }

}
